
export default {
    name: 'TransportAccessibility',

    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        map: {
            type: String,
            default: '',
        },
    },
};
